import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	canContactPrompt: {
		id: 'business-feedback-collector.can-contact-prompt',
		defaultMessage: 'Atlassian may contact me about this feedback.',
		description: 'Prompt asking user if they give consent to be contacted',
	},
	canContactPromptLink: {
		id: 'business-feedback-collector.can-contact-prompt-link',
		defaultMessage: 'Privacy policy',
		description: 'Privacy policy for user to visit and read',
	},
	enrollInResearchPrompt: {
		id: 'business-feedback-collector.enroll-in-research-prompt',
		defaultMessage: "I'd like to help improve Atlassian products by joining the {link}",
		description: 'A prompt that allows the customer to enrol in product research.',
	},
	enrollInResearchLink: {
		id: 'business-feedback-collector.enroll-in-research-link',
		defaultMessage: 'Atlassian Research Group',
		description:
			'A link in the prompt that allows the customer to see information about the research group',
	},
});
